import {MatricularDocente as Matricula} from 'containers/Admin/MatricularDocente'

export default function MatricularDocente() {
  return (
    <Matricula />
  );
}
